/** The render options shared by the export and the on-screen viewer, so both print the same document. */
const DOCUMENT_RENDER_OPTIONS = Object.freeze({
	locale: 'fr-FR',
	booleanLabels: Object.freeze({ trueLabel: 'Oui', falseLabel: 'Non' }),
});

export default DOCUMENT_RENDER_OPTIONS;
